import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["p", "br", "strong", "em", "ul", "ol", "li"];

export function bookDescriptionHtml(value) {
  const sanitized = DOMPurify.sanitize(String(value || ""), {
    ALLOWED_TAGS,
    ALLOWED_ATTR: [],
  }).trim();

  if (!sanitized) return "";

  const containsFormatting = /<(?:p|br|strong|em|ul|ol|li)\b/i.test(sanitized);
  if (containsFormatting) return sanitized;

  return `<p>${sanitized.replace(/\r?\n/g, "<br>")}</p>`;
}

export function bookDescriptionText(value) {
  const html = bookDescriptionHtml(value)
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/(?:p|li)>/gi, " ");
  const document = new DOMParser().parseFromString(html, "text/html");

  return (document.body.textContent || "").replace(/\s+/g, " ").trim();
}

export function bookDescriptionExcerpt(value, maximumLength = 200) {
  const text = bookDescriptionText(value);
  if (text.length <= maximumLength) return text;

  return `${text.slice(0, maximumLength).trim()}...`;
}
